import React, { useCallback } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import List from "../List";
import { createDateCreator, createDateEditor } from "../../editors/DateEditor";
import { dateFormatter } from "../../fomatters/DateFormatter";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      id={`simple-tabpanel-${index}`}
      role="tabpanel"
      hidden={value !== index}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 * TABLE MONEYCHANGE
 */
function Currency() {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [currency, setCurrency] = React.useState(null);

  const itemSelected = useCallback((item) => {
    setCurrency(item);
  }, []);

  return (
    <div className="flex flex-col gap-4 h-max">
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        className="w-full mb-2 overflow-x-scroll tabs-class"
      >
        <Tab label="Currency" />
        <Tab label="Exchange Rate" />
      </Tabs>
      <hr className="my-2" />
      <TabPanel className="tab-content" value={value} index={0}>
        <Crud
          title="Currency"
          getUrl={() => "/Agent/Currency_GetList"}
          // INSERT
          insertUrl={() => "/Agent/Currency_Insert"}
          insertParams={({ userId }, { currency, description, symbol }) => ({
            Currency: currency,
            Description: description,
            Symbol: symbol,
            IdUser: Number(userId),
          })}
          // UPDATE
          updateUrl={() => "/Agent/Currency_Update"}
          updateParams={(
            { userId },
            { idCurrency, currency, description, symbol }
          ) => ({
            IdCurrency: idCurrency,
            Currency: currency,
            Description: description,
            Symbol: symbol,
            IdUser: Number(userId),
          })}
          // DELETE
          deleteUrl={() => "/Agent/Currency_Delete"}
          deleteParams={({ userId }, id) => ({
            IdCurrency: id,
            IdUser: Number(userId),
          })}
        >
          <TableHeaderColumn
            visible="none"
            hiddenOnInsert
            autoValue={true}
            hidden
            isKey
            dataField="idCurrency"
          >
            IdCurrency
          </TableHeaderColumn>
          <TableHeaderColumn dataField="currency">Currency</TableHeaderColumn>
          <TableHeaderColumn dataField="description">
            Description
          </TableHeaderColumn>
          <TableHeaderColumn dataField="symbol">Symbol</TableHeaderColumn>
        </Crud>
      </TabPanel>
      <TabPanel className="tab-content" value={value} index={1}>
        <div className="flex flex-row gap-4">
          <List
            title="Currency"
            itemKey="idCurrency"
            getUrl={"/Agent/Currency_GetList"}
            itemSelected={itemSelected}
          >
            <TableHeaderColumn
              visible="none"
              hiddenOnInsert
              autoValue={true}
              hidden
              isKey
              dataField="idCurrency"
            >
              IdCurrency
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="currency"
              filter={{ type: "TextFilter", delay: 100 }}
            >
              Currency
            </TableHeaderColumn>
          </List>
          <Crud
            className="flex-1"
            title="Exchange Rate"
            getUrl={() =>
              `/Player/MoneyChange_GetList?idCurrency=${currency?.idCurrency}`
            }
            getProcess={(data) =>
              data.map((item) => ({
                IdComposed: `${item.idCurrency}-${item.toDate}`,
                ...item,
              }))
            }
            // INSERT
            insertUrl={() => "/Player/MoneyChange_Insert"}
            insertParams={({ userId }, { toDate, amountPerUnit }) => ({
              IdCurrency: currency?.idCurrency,
              ToDate: toDate,
              AmountPerUnit: amountPerUnit,
              IdUser: Number(userId),
            })}
            // UPDATE
            updateUrl={() => "/Player/MoneyChange_Update"}
            updateParams={(
              { userId },
              { idCurrency, toDate, amountPerUnit }
            ) => ({
              IdCurrency: idCurrency,
              ToDate: toDate,
              AmountPerUnit: amountPerUnit,
              IdUser: Number(userId),
            })}
            // DELETE
            deleteUrl={() => "/Player/MoneyChange_Delete"}
            deleteParams={({ userId }, _, { idCurrency, toDate }) => ({
              IdCurrency: idCurrency,
              ToDate: toDate,
              IdUser: Number(userId),
            })}
          >
            <TableHeaderColumn
              visible="none"
              hiddenOnInsert
              autoValue={true}
              hidden
              isKey
              dataField="IdComposed"
            >
              IdComposed
            </TableHeaderColumn>
            <TableHeaderColumn
              visible="none"
              hiddenOnInsert
              autoValue={true}
              hidden
              dataField="idCurrency"
            >
              IdCurrency
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="toDate"
              dataFormat={dateFormatter}
              editable={false}
              customInsertEditor={{
                getElement: createDateCreator,
              }}
            >
              To Date
            </TableHeaderColumn>
            <TableHeaderColumn dataField="amountPerUnit">
              Amount Per Unit
            </TableHeaderColumn>
          </Crud>
        </div>
      </TabPanel>
    </div>
  );
}

export default Currency;
